export enum UserType {
  Quantum = 1,
  BIExclusive = 2
}